import React from 'react';
import Typo from '../teal-react/components/atoms/Typo';
import AuditViewer from '../components/AuditTable/AuditViewer';

/*
import { useClient } from '../graphql/hooks';
const client = useClient();
<button onClick={() => client.resetStore()}>resetStore</button>
*/
// interface AuditViewerProps {
//   onClose: () => void;
//   table: string;
//   id: number;
// }
// const AuditViewer = ({ onClose, table, id }: AuditViewerProps) => {
//   const auditTable = 'audit' + capitalize(table);
//   const fields = get(schema, table);
//   const { data } = useQuery(
//     `query AuditViewer($where: String, $whereTable: String){
//       ${auditTable}(where: $where){
//         ${fields}
//       }
//       ${table}(where: $whereTable){
//         ${fields}
//       }
//     }`,
//     {
//       variables: {
//         where: JSON.stringify({
//           [`${auditTable}Id`]: id,
//         }),
//         whereTable: JSON.stringify({ id }),
//       },
//     }
//   );
//   if (!data) {
//     return null;
//   }

//   const aggregate = [...data[table]];
//   aggregate.push(...data[auditTable]);
//   console.log({ aggregate });

//   return (
//     <SimpleModal open={true} onClose={onClose}>
//       <div />
//     </SimpleModal>
//   );
// };

const TestPage = () => {
  return (
    <div>
      <AuditViewer table="qc" id={1} />

      {Typo.poopoo()}
    </div>
  );
};

export default TestPage;
